// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AppSystemWebApiModel from '../../model/app-system-web-api-model';
import AppSystemWebApiDTO from '../dto/app-system-web-api-dto';
import dtoSchema from '../schemas/app-system-web-api-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class AppSystemWebApiModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AppSystemWebApiDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.appSystemId = data.appSystemId;
      this.apiUrl = data.apiUrl ?? undefined;
      this.apiUser = data.apiUser ?? undefined;
      this.apiPassword = data.apiPassword ?? undefined;
      this.hasEncryptedApiPassword = data.hasEncryptedApiPassword;
      this.apiAuthenticationType = data.apiAuthenticationType ?? undefined;
      this.timeoutSeconds = data.timeoutSeconds;
      this.useProxy = data.useProxy;
      this.proxyUrl = data.proxyUrl ?? undefined;
      this.proxyUser = data.proxyUser ?? undefined;
      this.proxyPassword = data.proxyPassword ?? undefined;
      this.hasEncryptedProxyPassword = data.hasEncryptedProxyPassword;
      this.enableHttpsCertificateValidation = data.enableHttpsCertificateValidation;
      this.workspaceId = data.workspaceId ?? undefined;
      this.secret = data.secret ?? undefined;
      this.hasEncryptedSecret = data.hasEncryptedSecret;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {int64}
  */
  appSystemId?: number;
  /**
  */
  apiUrl?: string;
  /**
  */
  apiUser?: string;
  /**
  */
  apiPassword?: string;
  /**
  */
  hasEncryptedApiPassword?: boolean;
  /**
  */
  apiAuthenticationType?: string;
  /**
  * @type {int32}
  */
  timeoutSeconds?: number;
  /**
  */
  useProxy?: boolean;
  /**
  */
  proxyUrl?: string;
  /**
  */
  proxyUser?: string;
  /**
  */
  proxyPassword?: string;
  /**
  */
  hasEncryptedProxyPassword?: boolean;
  /**
  */
  enableHttpsCertificateValidation?: boolean;
  /**
  */
  workspaceId?: string;
  /**
  */
  secret?: string;
  /**
  */
  hasEncryptedSecret?: boolean;

  static toModel(dto: DeepPartial<AppSystemWebApiDTO>): AppSystemWebApiModel;
  static toModel(dto: DeepPartial<AppSystemWebApiDTO> | undefined | null): AppSystemWebApiModel | undefined;
  static toModel(dto: DeepPartial<AppSystemWebApiDTO> | undefined | null): AppSystemWebApiModel | undefined {
    return dto ? new AppSystemWebApiModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AppSystemWebApiModel> | AppSystemWebApiModel): AppSystemWebApiDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      appSystemId: unwrapped.appSystemId,
      apiUrl: unwrapped.apiUrl,
      apiUser: unwrapped.apiUser,
      apiPassword: unwrapped.apiPassword,
      hasEncryptedApiPassword: unwrapped.hasEncryptedApiPassword,
      apiAuthenticationType: unwrapped.apiAuthenticationType,
      timeoutSeconds: unwrapped.timeoutSeconds,
      useProxy: unwrapped.useProxy,
      proxyUrl: unwrapped.proxyUrl,
      proxyUser: unwrapped.proxyUser,
      proxyPassword: unwrapped.proxyPassword,
      hasEncryptedProxyPassword: unwrapped.hasEncryptedProxyPassword,
      enableHttpsCertificateValidation: unwrapped.enableHttpsCertificateValidation,
      workspaceId: unwrapped.workspaceId,
      secret: unwrapped.secret,
      hasEncryptedSecret: unwrapped.hasEncryptedSecret,
    } as AppSystemWebApiDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AppSystemWebApiModel, can not map to AppSystemWebApiDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
